import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { UmbracoHttpClient } from "@e-forsyning/common/http";

import { KontaktIndstillinger } from "../model/kontakt-indstillinger.model";
import { Kontakt } from "../model/kontakt.model";

@Injectable({ providedIn: "root" })
export class KontaktRepository {
    constructor(private readonly umbracoHttp: UmbracoHttpClient) {}

    public hentIndstillinger(): Observable<KontaktIndstillinger> {
        return this.umbracoHttp.hentSideData<KontaktIndstillinger>("kontakt");
    }

    public hentKontakt(forsyningNodeId: number): Observable<Kontakt> {
        return this.umbracoHttp.get(`GetVaerkInfo?id=${forsyningNodeId}`).pipe(map((data: any) => this.mapTo(data)));
    }

    private mapTo(kontakt: any): Kontakt {
        return {
            navn: kontakt.FirmaInfo.firmaNavn,
            adresse: kontakt.FirmaInfo.adresse,
            mail: kontakt.FirmaInfo.email,
            cvrNr: kontakt.FirmaInfo.cvrNr,
            postNr: kontakt.FirmaInfo.postNr,
            telefonNr: kontakt.FirmaInfo.telefonNr,
            logoUrl: kontakt.FirmaInfo.LogoUrl,
            website: kontakt.FirmaInfo.website,
            land: kontakt.FirmaInfo.land,
            by: kontakt.FirmaInfo.by
        };
    }
}
